import Vue from "vue"
import App from "./App.vue"
import vuetify from "./plugins/vuetify"

import VTipTap from "@peepi/vuetify-tiptap"

import store from "@universidade-franciscana/componente-front/src/store"
import { ValidationObserver, ValidationProvider, extend, localize } from "vee-validate"
import ptBr from "vee-validate/dist/locale/pt_BR.json"
import * as rules from "vee-validate/dist/rules"

import router from "./router/index"

import "@/services/api/interceptor-token.js"

import VueMask from "v-mask"

Vue.config.productionTip = false

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})
localize("pt_BR", ptBr)

Vue.use(VueMask)
Vue.use(VTipTap)

Vue.component("ValidationProvider", ValidationProvider)
Vue.component("ValidationObserver", ValidationObserver)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount("#app")